import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { permissaoUtils } from '@core/util/permissaoUtil';
import React, { useState } from 'react';
import { FaFileContract } from 'react-icons/fa';
import { ContratoAction, useContrato } from '../../store';
import {
  AdesaoContratoVisualizacao,
  AnexoContratoVisualizacao,
  DadosContratoVisualizacao,
  HistoricoContratoVisualizacao,
  PagamentoContratoVisualizacao,
  RescisaoContratoVisualizacao,
} from './secoes';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

const FORMA_RECEBIMENTO = {
  BOLETO: 'Boleto',
  PIX: 'Pix',
  CARTAO_DEBITO: 'Cartão de débito',
  CARTAO_CREDITO: 'Cartão de crédito',
  DINHEIRO: 'Dinheiro',
  TED_DOC: 'TED/DOC',
  CHEQUE: 'Cheque',
};

const Content = ({ contrato }) => {
  const [expanded, setExpanded] = useState('informacoesPagamento');

  const handleExpandedChange = (key, value) => {
    if (value) {
      setExpanded(key);
    } else {
      setExpanded('');
    }
  };

  const getDescricaoFormaCobranca = (formaCobranca) => {
    return FORMA_RECEBIMENTO[formaCobranca] || '-';
  };

  return (
    <>
      <DadosContratoVisualizacao contrato={contrato} getCurrency={getCurrency} />

      <CustomExpandedPanel
        title="Informações do pagamento"
        expanded={expanded === 'informacoesPagamento'}
        defaultExpanded
        onChange={(_, value) => handleExpandedChange('informacoesPagamento', value)}
      >
        <PagamentoContratoVisualizacao
          contrato={contrato}
          getDescricaoFormaCobranca={getDescricaoFormaCobranca}
          getCurrency={getCurrency}
        />
      </CustomExpandedPanel>

      {contrato?.adesao && (
        <CustomExpandedPanel
          title="Adesão"
          expanded={expanded === 'adesao'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('adesao', value)}
        >
          <AdesaoContratoVisualizacao
            adesao={contrato.adesao}
            getCurrency={getCurrency}
            getDescricaoFormaCobranca={getDescricaoFormaCobranca}
          />
        </CustomExpandedPanel>
      )}

      {contrato?.anexos && (
        <CustomExpandedPanel
          title="Documentos anexados"
          expanded={expanded === 'anexo'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('anexo', value)}
        >
          <AnexoContratoVisualizacao anexos={contrato?.anexos} />
        </CustomExpandedPanel>
      )}

      {contrato?.rescisao && (
        <CustomExpandedPanel
          title="Rescisão"
          expanded={expanded === 'rescisao'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('rescisao', value)}
        >
          <RescisaoContratoVisualizacao rescisao={contrato.rescisao} />
        </CustomExpandedPanel>
      )}

      {contrato?.historico && (
        <CustomExpandedPanel
          title="Histórico de alterações"
          expanded={expanded === 'historico'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('historico', value)}
        >
          <HistoricoContratoVisualizacao historico={contrato.historico} />
        </CustomExpandedPanel>
      )}
    </>
  );
};

const ContratoVisualizacaoModal = () => {
  const [state, dispatch] = useContrato();
  const { visualizar, registro } = state;

  const handleCancelar = () => ContratoAction.fecharModalCadastro(dispatch);

  return (
    <SimpleDialog open={visualizar} onClose={handleCancelar}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de contrato',
          icon: <FaFileContract />,
          toolbar: (
            <>
              <CancelButton onClick={handleCancelar}>Fechar</CancelButton>
              {// RNE-493
              permissaoUtils.contrato().editar &&
                (registro?.situacao === 'ATIVO' || registro?.situacao === 'ENCERRADO') && (
                  <EditButton
                    id="add-classe-root"
                    type="submit"
                    onClick={() => ContratoAction.requestEditar(dispatch, registro)}
                  >
                    Editar
                  </EditButton>
                )}
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content contrato={registro} />}
      />
    </SimpleDialog>
  );
};

export default ContratoVisualizacaoModal;
